// src/ProjectPost.js

import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { FaGithub, FaExternalLinkAlt, FaArrowLeft } from 'react-icons/fa';
import './ProjectPost.css';
import ImageLoader from './ImageLoader';

export default function ProjectPost() {
    const { id } = useParams();
    const [project, setProject] = useState(null);

    useEffect(() => {
        fetch('/projects.json')
            .then(res => res.json())
            .then(data => {
                // Sort by pinned first, then find by index
                const sorted = [...data].sort((a, b) => {
                    if (a.pinned && !b.pinned) return -1;
                    if (!a.pinned && b.pinned) return 1;
                    return 0;
                });
                const projectIndex = parseInt(id, 10);
                if (projectIndex >= 0 && projectIndex < sorted.length) {
                    setProject(sorted[projectIndex]);
                }
            })
            .catch(err => console.error('Error loading project:', err));
    }, [id]);

    if (!project) {
        return (
            <div className="project-post-container">
                <div className="project-post-loading">Loading...</div>
            </div>
        );
    }

    return (
        <div className="project-post-container">
            <div className="project-post-header">
                <Link to="/projects" className="back-button">
                    <FaArrowLeft size={16} />
                    <span>Back to Projects</span>
                </Link>
            </div>

            <div className="project-post-content">
                {/* Project demo or screenshot */}
                <div className="project-post-media">
                    {project.youtubeId ? (
                        <iframe
                            className="project-post-video"
                            src={`https://www.youtube.com/embed/${encodeURIComponent(project.youtubeId)}`}
                            title={`${project.title} demo video`}
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            referrerPolicy="strict-origin-when-cross-origin"
                            allowFullScreen
                        />
                    ) : (
                        <ImageLoader src={project.img} alt={project.title} />
                    )}
                </div>

                {/* Project Info */}
                <div className="project-post-info">
                    <h1 className="project-post-title">{project.title}</h1>

                    <div className="project-post-links">
                        {project.repo && (
                            <a href={project.repo} target="_blank" rel="noopener noreferrer" className="project-link github">
                                <FaGithub size={18} />
                                <span>View on GitHub</span>
                            </a>
                        )}
                        {project.demo && (
                            <a href={project.demo} target="_blank" rel="noopener noreferrer" className="project-link demo">
                                <FaExternalLinkAlt size={16} />
                                <span>{project.youtubeId ? 'Watch on YouTube' : 'Live Demo'}</span>
                            </a>
                        )}
                    </div>

                    {project.writeup ? (
                        <div className="project-post-description" dangerouslySetInnerHTML={{ __html: project.writeup }} />
                    ) : (
                        <p className="project-post-description">{project.blurb}</p>
                    )}

                    {project.tech && project.tech.length > 0 && (
                        <div className="project-post-tech">
                            <h3>Technologies</h3>
                            <div className="tech-tags">
                                {project.tech.map((t, idx) => (
                                    <span key={idx} className="tech-tag">{t}</span>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
